module.exports = __webpack_public_path__ + "files/fcf458d54aa7c316cbbcad3f8aa1bf7d.png";